module.exports = __webpack_public_path__ + "f59ec56d81de66530a68792f111de646.svg";